<ul>
  <li>
    A
    <b>consumer</b>
    (by specifying first name and last name, email, any phone number, or contact ID)
  </li>
</ul>
